import { SIP_GATEWAY } from "callable-data-objects";
import { get as getWidget } from "Components/Device/Flow/constants";
import ConnectTo from "Components/Device/Forms/ConnectTo";
import General from "Components/Device/Forms/General";
import SipGatewayEdit from "Components/Device/SipGateway/SipGatewayEdit";
import DeleteForm from "Components/Shared/DeleteForm";
import React, { useState } from "react";
import { Grid, Icon, Menu } from "semantic-ui-react";
import EndpointForm from "../Forms/EndpointForm";

const SipGatewayView = () => {
  const [activeMenu, setActiveMenu] = useState<string | undefined>("trunks");
  const widget = getWidget(SIP_GATEWAY);
  const isHandler = () => {
    return (
      ["onComplete", "onBusy", "onFail", "onNoAnswer"].find(
        (s) => activeMenu === s
      ) !== undefined
    );
  };

  return (
    <Grid stackable columns={2}>
      <Grid.Column width={3}>
        <Menu vertical fluid pointing size='small'>
          <Menu.Item header>
            <Icon name={widget.icon} color={widget.color} />
            {widget.name}
          </Menu.Item>
          <Menu.Item
            name='trunks'
            active={activeMenu === "trunks"}
            onClick={(e, { name }) => setActiveMenu(name)}
          >
            Trunks
          </Menu.Item>
          <Menu.Item
            name='general'
            active={activeMenu === "general"}
            onClick={() => setActiveMenu("general")}
          >
            General Configuration
          </Menu.Item>
          <Menu.Item
            name='endpoint'
            active={activeMenu === "endpoint"}
            onClick={() => setActiveMenu("endpoint")}
          >
            Call Configuration
          </Menu.Item>
          <Menu.Item
            name='onComplete'
            active={activeMenu === "onComplete"}
            onClick={() => setActiveMenu("onComplete")}
          >
            On Complete
          </Menu.Item>
          <Menu.Item
            name='onNoAnswer'
            active={activeMenu === "onNoAnswer"}
            onClick={() => setActiveMenu("onNoAnswer")}
          >
            On No Answer
          </Menu.Item>
          <Menu.Item
            name='onBusy'
            active={activeMenu === "onBusy"}
            onClick={() => setActiveMenu("onBusy")}
          >
            On Busy
          </Menu.Item>
          <Menu.Item
            name='onFail'
            active={activeMenu === "onFail"}
            onClick={() => setActiveMenu("onFail")}
          >
            On Fail
          </Menu.Item>
          <Menu.Item
            name='delete'
            active={activeMenu === "delete"}
            onClick={(e, { name }) => setActiveMenu(name)}
          >
            <b style={{ color: "red" }}>Delete</b>
          </Menu.Item>
        </Menu>
      </Grid.Column>
      <Grid.Column width={13}>
        {activeMenu === "general" && <General />}
        {activeMenu === "trunks" && <SipGatewayEdit />}
        {activeMenu === "delete" && <DeleteForm />}
        {activeMenu === "endpoint" && <EndpointForm fieldName='sipGateway' />}
        {isHandler() && <ConnectTo type='sipGateway' field={activeMenu} />}
      </Grid.Column>
    </Grid>
  );
};

export default SipGatewayView;
